import React from "react"
import classNames from "classnames"

import componentStyles from "./SmallProjectCard.module.scss"
import { ProjectItem } from "../../hooks"
import { useIntl } from "gatsby-plugin-intl"
import projectsStyles from "../../pages/projects.module.scss"
import Button from "../Button/Button"

interface SmallProjectCardProps extends ProjectItem {
  className?: string
}

const SmallProjectCard: React.FC<SmallProjectCardProps> = ({
  className,
  thumbnail,
  title,
  link,
  color,
  textColor,
  banner,
  backgroundSize,
  rightBlockStyle,
  buttonColor,
  leftBlockStyle
}) => {
  const intl = useIntl()
  const cardClasses = classNames(
    componentStyles.project,
    className,
  )
  const thumbnailClasses = classNames(componentStyles.projectThumbnail)
  const linkClasses = classNames(componentStyles.projectLink)
  const blockWithBackground = classNames(
    projectsStyles.blockPreviewItem,
    projectsStyles.backgroundBlock
  )

  const getFullPath = (url: string) => {
    if (url) {
      return `/projects/${url}/`
    }
    return ""
  }

  link = link ? getFullPath(link) : undefined

  const Thumbnail = !thumbnail ? (
    <picture className={thumbnailClasses} />
  ) : (
    <picture className={thumbnailClasses}>
      <source
        type="image/webp"
        srcSet={thumbnail.childImageSharp.fixed.srcSetWebp}
      />
      <source
        type="image/png"
        srcSet={thumbnail.childImageSharp.fixed.srcSet}
      />
      <img
        className={componentStyles.projectThumbnailImage}
        src={thumbnail.childImageSharp.fixed.src}
        srcSet={thumbnail.childImageSharp.fixed.srcSet}
        width={thumbnail.childImageSharp.fixed.width}
        height={thumbnail.childImageSharp.fixed.height}
        alt={`${(title && intl.formatMessage({ id: title })) || ""} thumbnail`}
      />
    </picture>
  )
  return (
    <article className={cardClasses}>
      <div
        className={className ? className: projectsStyles.blockPreviewItem}
        key={link}
        style={banner ?
          {backgroundColor: color, backgroundImage: banner, backgroundSize: backgroundSize}
           :
          {backgroundColor: color, background: color}
        }
      >
        <div className={projectsStyles.blockPreviewItemLeft} style={{background: leftBlockStyle}}>
          <h3 className={projectsStyles.blockPreviewTitle} style={{color: textColor}}>
            {intl.formatMessage({ id: title })}
          </h3>
          <Button
            to={link}
            className={projectsStyles.blockPreviewItemLeftButton}
            color={ buttonColor }
          >
            {intl.formatMessage({ id: "index.projects.see-project" })}
          </Button>
        </div>
        <div className={projectsStyles.blockPreviewItemRight} style={{display: rightBlockStyle}}>
          {Thumbnail}
        </div>
      </div>
    </article>
  )
}

export default SmallProjectCard
